'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$dateDisplayFormats", function () {
  return {
    DATE: "dddd D MMM YYYY",
    LONG: "DD/MM/YYYY HH:mm:ss",
    MEDIUM: "DD/MM/YYYY HH:mm",
    SHORT: "DD/MM/YYYY",
    URL_SHORT: "YYYY-MM-DD",
    MONTH_AND_YEAR: "MMMM YYYY",
    YEAR: "YYYY",
    TIME: "HH:mm:ss"
  };
});
ngModule.factory("$dateFormat", function ($dateDisplayFormats, $serverDateFormat, $serverShortDateFormat) {
  var $dateFormat = function $dateFormat(date, format) {
    if (date === null || date === "") {
      return null;
    }
    return moment(date).format(format);
  };
  _.extend($dateFormat, {
    /**
     * Returns a formatter function for given format.
     *
     * @param format The format to use for this formatter
     */
    formatter: function formatter(format) {
      return function (date) {
        return $dateFormat(date, format);
      };
    },
    custom: function custom(date, format) {
      return $dateFormat(date, format);
    },
    /**
     * YYYY-MM-DD HH:mm:ss
     */
    server: function server(date) {
      return $dateFormat(date, $serverDateFormat);
    },
    /**
     * YYYY-MM-DD
     */
    serverShort: function serverShort(date) {
      return $dateFormat(date, $serverShortDateFormat);
    },
    /**
     * ex : (fr) Lundi 12 Mars 2013
     */
    date: function date(_date) {
      return $dateFormat(_date, $dateDisplayFormats.DATE);
    },
    /**
     * ex : (fr) 21/09/2012 14:52:10
     */
    long: function long(date) {
      return $dateFormat(date, $dateDisplayFormats.LONG);
    },
    /**
     * ex : (fr) 21/09/2012 14:52
     */
    medium: function medium(date) {
      return $dateFormat(date, $dateDisplayFormats.MEDIUM);
    },
    /**
     * ex : (fr) 21/09/2012
     */
    short: function short(date) {
      return $dateFormat(date, $dateDisplayFormats.SHORT);
    },
    /**
     * date au format jj-mm-yyyy qui peut etre passé dans l'url
     */
    urlShort: function urlShort(date) {
      return $dateFormat(date, $dateDisplayFormats.URL_SHORT);
    },
    /**
     * ex : 2012
     */
    year: function year(date) {
      return $dateFormat(date, $dateDisplayFormats.YEAR);
    },
    /**
     * ex : 14:52:10
     */
    time: function time(date) {
      return $dateFormat(date, $dateDisplayFormats.TIME);
    }
  });
  return $dateFormat;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/types/date/dateFormat.js
// module id = 2725
// module chunks = 13